import type { ApiError } from '@izimi/api';

export const isCertinotError = (error: Record<string, unknown>): error is ApiError => {
  return error.userMessage != null;
};
